<template>
  <div class="buttonContainer" data-test="recorderShareScreenArea">
    <!-- AI Avatar-->
    <div  data-test="aiAvatarChooseButton" class="buttonSelector" :class="isAIAvatarChoose?'selected':''"
          @click="chooseAIAvatar">
      <w-icon class="iconSelector" icon="creation-outline"/>
      <div class="labelButtonSelector">{{ $t('screenLayoutSelector.aiAvatar') }}</div>
      <div class="betaInfo" v-if="false">{{$t('generic.beta')}}</div>
    </div>
    <!-- Background Button -->
    <div data-test="virtualScreenChooseButton" class="buttonSelector" :class="isVirtualScreenCastChoose?'selected':''"
         @click="chooseVirtualScreenCast">
      <w-icon class="iconSelector" icon="card-account-details-outline"/>
      <div class="labelButtonSelector">{{ $t('screenLayoutSelector.scene') }}</div>
    </div>
    <!-- screencast Button -->
    <div data-test="screenCastChooseButton" class="buttonSelector" :class="isScreenCastChoose?'selected':''"
         @click="chooseScreenCast">
      <w-icon class="iconSelector" icon="monitor"/>
      <w-icon class="avatarIconSelector" icon="account" size="small"/>
      <div class="labelButtonSelector">{{ $t('screenLayoutSelector.screen') }}</div>
    </div>
    <!-- Webcam button -->
    <div data-test="webcamOnlyChooseButton" class="buttonSelector" :class="isWebcamChoose?'selected':''"
         @click="chooseWebcamFull">
      <w-icon class="iconSelector" icon="webcam"/>
      <div class="labelButtonSelector">{{ $t('screenLayoutSelector.webcam') }}</div>
    </div>
  </div>
</template>

<script lang="ts">
import {Component, Vue} from 'vue-property-decorator';
import WButton from '@/components/wrapper/w-button.vue';
import store from '@/store';
import {
  RECORD_MAIN_VIDEO_TYPE,
  RECORD_MAIN_VIRTUAL_BACKGROUND,
  RECORD_STICKER_FULLSCREEN,
  RECORD_STICKER_MUTE,
  RECORD_STICKER_VIDEO_MUTE,
  RECORD_STICKER_VIDEO_TYPE, SELECT_SEGMENT
} from "@/store/recordingState/recordStateAction";
import {SourceVideoType} from '@/enum/SourceVideoEnum';
import {setActionEvent} from '@/utils/tracker';
import {ActionEvent} from '@/enum/TrackerEnum';
import randomInt from 'random-int';
import {listOfAnonymeScreenVirtualBackground} from '@/utils/filterUtils';
import WIcon from '@/components/wrapper/w-icon.vue';
import {confirmation, confirmationDanger, inform} from '@/utils/dialog';
import {PaymentPlanEnum} from "@/store/workspace/workspaceModel";
import UpgradePlanTag from "@/components/upgradePlan/UpgradePlanTag.vue";
import {canMoveWeetFromCurrentWorkspace, hasPaidWorkspace} from "@/utils/workspaceUtil";
import router from "@/router";
import WorkspaceMovePanel from "@/components/workspace/WorkspaceMovePanel.vue";
import {Weet} from "@/store/weet/weetModel";
import {STORE_LINK_REDIRECT_AFTER_PAYMENT} from "@/store/persistedInformation/persistAction";
import { INIT_SLIDES_IF_NEEDED } from "@/store/slides2Video/slides2VideoAction";
import { hasSlideWorkInProgress } from "@/utils/slides/slideUtil";
import { OPEN_AVATAR_EDITING_CONTENT } from "@/store/AIAvatar/AIAVatarAction";


@Component({
  components: {WorkspaceMovePanel, UpgradePlanTag, WIcon, WButton},
})
export default class ScreenLayoutSelector extends Vue {

  private moveWeetPanel: boolean = false;


  get selectedWorkspaceID(): string {
    return store.getters.getSelectedWorkspace;
  }

  get myWeet(): Weet | null {
    return store.getters.getMyWeet(store.getters.getEditingWeetID) || null;
  }


  get isInPremiumWorkspace(): boolean {
    var currentWorkspace = store.getters.getSelectedWorkspace;
    if (currentWorkspace) {
      if (currentWorkspace) {
        return currentWorkspace.plan !== PaymentPlanEnum.FREE;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  get isRecording(): boolean {
    return !store.getters.isStartRecordingAivailable;
  }

  get isScreenCastChoose(): boolean {
    return store.getters.getMainRecordSource === SourceVideoType.SCREENCAST;
  }

  get isUploadChoose(): boolean {
    return store.getters.getMainRecordSource === SourceVideoType.UPLOAD;
  }

  get isVirtualScreenCastChoose(): boolean {
    return store.getters.getMainRecordSource === SourceVideoType.VIRTUAL_SCREENCAST;
  }

  get isNoneChoose(): boolean {
    return store.getters.getMainRecordSource === SourceVideoType.NONE;
  }

  get isWebcamChoose(): boolean {
    return store.getters.getMainRecordSource === SourceVideoType.WEBCAM;
  }

  get isAIAvatarChoose():boolean{
    return store.getters.getMainRecordSource===SourceVideoType.AIAVATAR
  }

  get canMoveWeet(): boolean {
    return canMoveWeetFromCurrentWorkspace();
  }

  private async moveOrGoToPayment() {
    // if i'm in PS
    // and i have a paid workspace
    // and i can move my weet
    if (!this.selectedWorkspaceID && hasPaidWorkspace() && this.canMoveWeet) {
      await confirmation(
          this.$t('screenLayoutSelector.uploadPremium.move.description').toString(),
          this.$t('screenLayoutSelector.uploadPremium.move.title').toString(),
      );
      this.moveWeetPanel = true;
    } else {
      try {
        await confirmation(this.$t('screenLayoutSelector.uploadPremium.close.description').toString(),
            this.$t('screenLayoutSelector.uploadPremium.close.title').toString());
        this.$emit('close');
        store.dispatch(STORE_LINK_REDIRECT_AFTER_PAYMENT,document.location.href)
        router.push({name: 'MyWorkspacePayment'});
      } catch (e) {
        //nothing to do; the user don't want to quit the edit
      }
    }

  }

  /**
   * Leaving the AI avatar mode drops the slide editor, and a destruction cannot be vetoed
   * once started: so ask here, before the source actually changes, and do nothing on cancel.
   */
  private async canLeaveAIAvatar(): Promise<boolean> {
    if (!this.isAIAvatarChoose || !hasSlideWorkInProgress()) {
      return true;
    }
    try {
      await confirmationDanger(
          this.$t('screenLayoutSelector.leaveAIAvatar.description').toString(),
          this.$t('screenLayoutSelector.leaveAIAvatar.title').toString(),
          this.$t('screenLayoutSelector.leaveAIAvatar.confirm').toString(),
          this.$t('generic.cancel').toString(),
      );
      return true;
    } catch (e) {
      // the user cancelled: stay in the slide editor
      return false;
    }
  }

  public async chooseFile(file: File) {
    if (!await this.canLeaveAIAvatar()) {
      return;
    }
    if (file) {
      this.$emit('input', file);
      store.dispatch(RECORD_STICKER_VIDEO_TYPE, SourceVideoType.NONE);
      store.dispatch(RECORD_MAIN_VIDEO_TYPE, SourceVideoType.NONE).then(() => {
        store.dispatch(RECORD_MAIN_VIDEO_TYPE, SourceVideoType.UPLOAD);
      });
    }
  }

  public chooseAIAvatar(){
    if (this.isRecording || this.isAIAvatarChoose) {
      return;
    }
    store.dispatch(SELECT_SEGMENT,null);
    // keep a deck already started: entering the mode must not destroy the user's slides
    store.dispatch(INIT_SLIDES_IF_NEEDED)
    store.dispatch(OPEN_AVATAR_EDITING_CONTENT,false)

    store.dispatch(RECORD_STICKER_VIDEO_TYPE, SourceVideoType.NONE);

    // remove sceeen if already and ask for another screen
    store.dispatch(RECORD_MAIN_VIDEO_TYPE, SourceVideoType.NONE).then(() => {
      store.dispatch(RECORD_MAIN_VIDEO_TYPE, SourceVideoType.AIAVATAR);
      // remove fullscreen if need
      if (store.getters.isStickerFullscreen) {
        store.dispatch(RECORD_STICKER_FULLSCREEN);
      }
    });
  }

  public async chooseWebcamFull() {
    if (this.isRecording || this.isWebcamChoose) {
      return;
    }
    if (!await this.canLeaveAIAvatar()) {
      return;
    }
    store.dispatch(SELECT_SEGMENT,null);
    if (store.getters.isStickerMute) {
      inform(this.$t('stickers.button.micro.toast.on').toString(), 'top', 'light');
      store.dispatch(RECORD_STICKER_MUTE);
    }
    if (store.getters.isStickerVideoMute) {
      inform(this.$t('stickers.button.webcam.toast.on').toString(), 'top', 'light');
      setTimeout(() => {
        store.dispatch(RECORD_STICKER_VIDEO_MUTE);
      }, 100);
    }

    store.dispatch(RECORD_STICKER_VIDEO_TYPE, SourceVideoType.NONE);

    // remove sceeen if already and ask for another screen
    store.dispatch(RECORD_MAIN_VIDEO_TYPE, SourceVideoType.NONE).then(() => {
      store.dispatch(RECORD_MAIN_VIDEO_TYPE, SourceVideoType.WEBCAM);
      // remove fullscreen if need
      if (store.getters.isStickerFullscreen) {
        store.dispatch(RECORD_STICKER_FULLSCREEN);
      }
    });
  }

  public async chooseScreenCast() {
    if (this.isRecording) {
      return;
    }
    if (!await this.canLeaveAIAvatar()) {
      return;
    }
    store.dispatch(SELECT_SEGMENT,null);
    store.dispatch(RECORD_STICKER_VIDEO_TYPE, SourceVideoType.WEBCAM);
    // remove sceeen if already and ask for another screen
    store.dispatch(RECORD_MAIN_VIDEO_TYPE, SourceVideoType.NONE).then(() => {
      store.dispatch(RECORD_MAIN_VIDEO_TYPE, SourceVideoType.SCREENCAST);
      // remove fullscreen if need
      if (store.getters.isStickerFullscreen) {
        store.dispatch(RECORD_STICKER_FULLSCREEN);
      }
    });
  }

  public async chooseVirtualScreenCast() {
    if (this.isRecording) {
      return;
    }
    if (!await this.canLeaveAIAvatar()) {
      return;
    }
    store.dispatch(SELECT_SEGMENT,null);
    const listOfBackground = listOfAnonymeScreenVirtualBackground();
    const value = listOfBackground[randomInt(listOfBackground.length - 1)].value;
    store.dispatch(RECORD_MAIN_VIRTUAL_BACKGROUND, value);
    setActionEvent(ActionEvent.record_virtual_screen, {virtual_screen_background: value});

    store.dispatch(RECORD_STICKER_VIDEO_TYPE, SourceVideoType.WEBCAM);

    // remove sceeen if already and ask for another screen
    store.dispatch(RECORD_MAIN_VIDEO_TYPE, SourceVideoType.NONE).then(() => {
      store.dispatch(RECORD_MAIN_VIDEO_TYPE, SourceVideoType.VIRTUAL_SCREENCAST);
      // put fullscreen if need
      if (!store.getters.isStickerFullscreen) {
        store.dispatch(RECORD_STICKER_FULLSCREEN);
      }
    });
  }
}
</script>

<style scoped lang="scss">
@import '@/scss/shadows.scss';

// Tabs grouped in a light pill, the selected one raised in white
.buttonContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  padding: 4px;
  background: var(--light);
  border-radius: 12px;

  .buttonSelector {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 20px;
    background: transparent;
    cursor: pointer;
    border-radius: 8px;
    position: relative;

    .upgradePlanTag {
      position: absolute;
      bottom: 4px;
      right: 0px;
    }

    .iconSelector {
      color: var(--light2);
    }

    .avatarIconSelector {
      position: absolute;
      bottom: 8px;
      left: 34px;
      color: var(--light2);
      background: transparent;
    }

    .labelButtonSelector {
      font-size: 16px;
      font-weight: 600;
      color: var(--light2);
      white-space: nowrap;
    }
    .betaInfo{
      position: absolute;
      font-size: 12px;
      width: 50%;
      left: 25%;
      border-radius: 8px;
      color: white;
      background: var(--secondary);
    }
    &.selected {
      background: var(--white);
      box-shadow: 0 1px 4px rgba(10, 8, 47, 0.08);

      .avatarIconSelector {
        background: var(--white);
      }

      .iconSelector, .labelButtonSelector {
        color: var(--black);
      }
    }

    &:hover:not(.selected) {
      background: var(--light1);

      .avatarIconSelector {
        background: var(--light1);
      }
    }
  }
}
</style>
